import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
//import { configure, setAddon } from '@storybook/react';
import { BreadcrumbPage } from "../../shared";
import CheckIcon from '@material-ui/icons/Check';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import { InputLabel, TextareaAutosize } from '@material-ui/core';
import Form from 'react-bootstrap/Form'
import FormControl from "@material-ui/core/FormControl";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import { getCookie } from "../../services/Cookies";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
//import {SupportFormat} from "./SupportFormat";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
//import supportuser from "./UserForm";
import grey from "@material-ui/core/colors/grey";
import clsx from "clsx";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import userObj from "./Userdomain";
import Select from '@material-ui/core/Select';
import {
  FormHelperText,
  Input,
  InputBase,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  mainBox: {
    width: "95%",
    height: "500px",
    backgroundColor: '#fff',
    marginRight: '2rem',
    marginLeft: '2rem',
    boxShadow: "0px 4px 5px -3px rgba(1,1,1,0.75)",
  },
  form: {
    textAlign: "center",
    width: '60vw',
    height: '60vh',
    position: 'absolute',
    top: "50%",
    left: "50%",
    transform: 'translate(-50%,-50%)',
    marginTop: "5rem !important"


  },
  item: {
    width: "50px",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "338px",
    "& select": {
      padding: "6px"
    }
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#000",
    color: "#fff",
  },
  body: {},
}))(TableCell);

const StyledSubTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: grey[400],
  },
  body: {},
}))(TableCell);

{/*Row.propTypes = {
  row: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
};*/}

function Support(props) {
  const BreadcrumbList = [{ name: "Customer/Add", url: "" }];
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [formObj, setFormObj] = useState(userObj);
  const [value, setValue] = useState('');
  const [selectedCustomerKey, setSelectedCustomerKey] = React.useState([]);
  const [customerDetailsBySearch, setCustomerDetailsBySearch] = React.useState([]);


  const onTextChange = (event) => {
  
    ////console.log(event);
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  };

  const autoTextCustomer = (event) => {
    let searchStr = event.target.value;
    setValue(searchStr);
    ////console.log(searchStr,"SEARCH");
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
    getRequest(url)
      .then((res) => {
        // ////console.log(res);
        if (res.status == 200) {
          let totalArray = [];
          res.data.map((item) => {
            if (item.customerName || item.customerkeys) {
              totalArray.push(item);
            }
          });
          setCustomerDetailsBySearch(totalArray);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const getAllUser = () => {
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `SupportTicket/retriveTicket`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setRegisteredUsers(res.data);
          //onDownloadPic(res.data[0].attachmentId);
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }

  useEffect(() => {
    getAllUser();
  }, []);
  ////console.log(registeredUsers);
  const onChangeText = (event) => {
    ////console.log(event);
    setFormObj(event.target.value)
  };
  const submitdomain = async ()=> {
   const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + "BlacklistDomain";
    dispatch({ type: LOADING, payload: true });
      getRequest(url)
      .then((res)=>{
        let domainBl =[];
        res.data.forEach((d)=>{       
          if(res.status == 200){
          dispatch({ type: LOADING, payload: false });
          console.log("res", res);
          domainBl.push(d.domainName);
          }
        })

          if(domainBl.includes(formObj.domainName)){
            ToastError("Entered Domain name is already Exist in Blacklisted ");
          }
          else{
            updateUserSubmit();
          }
      })

  }


  const updateUserSubmit = async (event) => {
    //
    //debugger
    let formObjData = { CustomerName: value, DomainName: formObj.domainName };

    //event.preventDefault();
    let D_name = formObj.domainName;
    if (formObjData.CustomerName==="" || formObjData.DomainName=== ""){
      ToastError("Fill All Details");
      return false;
    }

    function validate_domain(item){
  
    var valid = false;
    var len = 0;
  
      
    if(item.includes(".com")){
      var arr2 = item.split('.com');
      len = arr2.length;
     // console.log(arr2,'-',arr2.length,'\n');
      
      if(len < 2){
        valid = false;
      }
      
      if(len == 2){
        if(arr2[len-1] == ''){
          valid = true;
        }
        
        if(arr2[len-1].charAt(0)){
          valid = true;
        }
        
        if(arr2[0].includes('.')){
          valid = false;
        }
        
      }
      
      if(len > 2){
        valid = false;
      }
      }else{
      var arr1= item.split('.');
      len=arr1.length;
      console.log('else : ',arr1)
      if(len <=3){
        if(arr1[0] != arr1[len-1]){
          valid = true;
        }
      }
      
      
      }
    return valid;
    }

    //if (D_name.indexOf('.', D_name.indexOf('.',+1)+1) != -1) {
     if(!validate_domain(D_name)){
      ToastError("unsucessfull");
    } else {
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CustomerDomain/AddCustomerDomain`;
      dispatch({ type: LOADING, payload: true });
      //
      await postRequest(url, formObjData)
        .then((res) => {
          if (res.status == 200) {
            //
            dispatch({ type: LOADING, payload: false });
            setFormObj({ ...formObj });
            ToastSuccess("Saved Successfully");

            history.push("/dashboard/Customerdomain");
          } else {
            ToastError("unsucessfull");
            dispatch({ type: LOADING, payload: false });
          }
        
        })

        .catch((error) => {
          ////console.log(error);
          dispatch({ type: LOADING, payload: false });
          ToastError("Error ");
        });
    //}
      }

    ////console.log(formObj); // }
  };

  return (
    <div >

      <Box pb={3} pt={0} display="dlock">
        <BreadcrumbPage rows={BreadcrumbList} />
      </Box>
      <div className={classes.mainBox}>

        <Form className={classes.form}>
          <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Customer Name
            </Form.Label>
            <Col sm={4}>
              <FormControl variant="outlined" value={formObj.customerName} name="customerName" onChange={onTextChange} className={classes.formControl + " cust-select-1"}>

                <Autocomplete
                  id="combo-box-demo"
                  options={customerDetailsBySearch}
                  name="contractKeys"
                  inputValue={value}
                  onInputChange={(event, newInputValue) => {
                    ////console.log(newInputValue);

                  }}
                  // value={formObj.customerKeys[0]}
                  onChange={(event, newValue) => {
                    ////console.log(newValue, 'newValue...');
                    if (newValue) {
                      setValue(newValue.customerName);
                      setSelectedCustomerKey(newValue.customerKey);
                      ////console.log("Selected customerKey:",newValue);

                    } else {
                      // setContractDetails([]);
                      // setFormObj({ ...formObj, ["customerKeys"]:[]})
                    }
                  }}
                  getOptionLabel={(option) => option.customerName}
                  // style={{ width: 300 }}
                  renderInput={(params) => <TextField {...params}
                    onChange={autoTextCustomer}
                    label="" className={clsx(classes.autoTextbox)} />}
                />
              </FormControl>
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
            <Form.Label column sm={2}>
              Domain Name
            </Form.Label>
            <Col sm={4}>
              <Form.Control value={formObj.domainName} name="domainName" onChange={onTextChange} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="justify-content-md-center">
            <Col sm={{ span: 4, offset: 2 }}>
              <Button className={classes.btnStyle2} onClick={submitdomain}>Save</Button>
              <Button type="button" className={classes.btnStyle2} onClick={() => {
                history.push("/dashboard/Customerdomain");
              }} >Cancel</Button>
            </Col>

          </Form.Group>
        </Form>
      </div>

    </div>
  )
}


export default Support

